import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './ModuleContentActions.style';

const ModuleContentActions = ({
  label,
  variant,
  padded,
  children,
  className: classNameProp,
  ...other
}) => {
  const className = clsx(styles.root, classNameProp, {
    [styles.padded]: padded,
  });
  const asMap = {
    medium: 'h4',
    large: 'h3',
    xLarge: 'h2',
  };

  return (
    <div className={className} {...other}>
      <Text as={asMap[variant]}>{label}</Text>
      <div>{children}</div>
    </div>
  );
};

ModuleContentActions.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(['medium', 'large', 'xLarge']),
  padded: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ModuleContentActions.defaultProps = {
  label: null,
  variant: 'large',
  padded: false,
  className: '',
};

export default ModuleContentActions;
